import type { AssetFragment } from "./asset-fragment";

// Field instances share handles across entry types but GraphQL fragments
// need concrete types, so recurring field groups live here as raw string
// snippets that get interpolated into per-type inline fragments:
//
//   ... on page_Entry {
//     ${metaFieldsSnippet}
//   }
//
// Add more snippets (hero fields, …) as the project's field instances grow.

export const metaFieldsSnippet = `
  metaTitle
  metaDescription
  ogImage {
    ...assetFragment
    ogImageUrl: url @transform(handle: "opengraph")
  }
  metaTags
`;

export type MetaFields = {
  metaTitle: string | null;
  metaDescription: string | null;
  ogImage: (AssetFragment & { ogImageUrl: string | null })[];
  metaTags: string | null;
};
